let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4h6Er")).then(() => parcelRequire('3oO3p'));